import { formatAssetClassLabel, isTradedAssetClassesField } from "./tradingViewBroker";

export { formatAssetClassLabel, isTradedAssetClassesField };

export const MT5_BROKER_SLUG = "mt5";

export const MT5_DEFAULT_ASSET_CLASSES = [
  "commodity",
  "crypto",
  "energy",
  "equity",
  "fx",
  "index",
  "metal",
] as const;

export function isMt5Broker(brokerName: string | null | undefined): boolean {
  return String(brokerName || "").toLowerCase() === MT5_BROKER_SLUG;
}

/** Hidden on the form — not collected on import (account comes from the report). */
export function isMt5HiddenImportField(field: string): boolean {
  const lower = field.toLowerCase();
  return lower === "broker_name" || lower === "account_name";
}

export const MT5_IMPORT_FIELD_LABELS: Record<string, string> = {
  time_zone: "Report timezone",
  traded_asset_classes: "Asset classes",
  executing_broker_name: "Executing broker",
};

export function mt5ImportFieldLabel(field: string, fallback: string): string {
  return MT5_IMPORT_FIELD_LABELS[field] ?? fallback;
}

export function buildMt5XlsxImportParams(
  values: Record<string, string>,
  assetClasses: string[]
): Record<string, string | string[]> {
  const timeZone = (values.time_zone || values.timeZone || "").trim();
  const executingBrokerName = (
    values.executing_broker_name ||
    values.executingBrokerName ||
    ""
  ).trim();
  const params: Record<string, string | string[]> = {
    broker_name: MT5_BROKER_SLUG,
    time_zone: timeZone,
    traded_asset_classes: assetClasses.map((c) => c.trim()).filter(Boolean),
  };
  if (executingBrokerName) {
    params.executing_broker_name = executingBrokerName;
  }
  return params;
}

export function isMt5XlsxFile(file: File): boolean {
  return file.name.toLowerCase().endsWith(".xlsx");
}

export function formatMt5ReconciliationWarning(payload: Record<string, unknown> | null | undefined): string | null {
  if (!payload || payload.reconciliation_ok !== false) return null;
  const meta = (payload.report_meta ?? payload.reportMeta) as Record<string, unknown> | undefined;
  const positions = meta?.positions_count ?? meta?.positionsCount;
  const resultsTrades = meta?.results_total_trades ?? meta?.resultsTotalTrades;
  const profitSum = meta?.positions_profit_sum ?? meta?.positionsProfitSum;
  const netProfit = meta?.results_total_net_profit ?? meta?.resultsTotalNetProfit;
  const parts: string[] = [
    "The Positions and Results sections in your report did not fully agree.",
  ];
  if (positions != null && resultsTrades != null) {
    parts.push(`Positions: ${positions} trades vs Results total: ${resultsTrades}.`);
  }
  if (profitSum != null && netProfit != null) {
    parts.push(`Positions profit sum: ${profitSum} vs Results net profit: ${netProfit}.`);
  }
  return parts.join(" ");
}
